import typeToReducer from 'type-to-reducer';
import omit from 'lodash/omit';

import * as types from './types';

const mergePayload = (state, action) => ({ ...state, ...action.payload });

export default typeToReducer(
  {
    [types.NOTIFICATION_PUSH]: mergePayload,
    [types.NOTIFICATION_FETCH]: {
      FULFILLED: mergePayload,
    },
    [types.NOTIFICATION_DISMISS]: (state, { payload: { notificationId } }) =>
      omit(state, notificationId),
  },
  {},
);
